
if (!customElements.get('table-rows-toggler')) {
  customElements.define(
    'table-rows-toggler',
    class TableRowsToggler extends HTMLElement {
      constructor() {
        super();

        this.table = null;
        this.tableRows = null;
        this.rowsToShow = null;
        this.buttons = null;
      }

      connectedCallback() {
        this.table = document.getElementById(`${this.dataset.tableId}`) || false;
        this.rowsToShow = this.dataset.rows;
        this.buttons = this.querySelectorAll('button');
        const mobile = window.matchMedia("(max-width: 480px)").matches;

        if (this.table) this.tableRows = this.table.querySelectorAll('.table__row');

        if (mobile && this.tableRows){
          this.toggleRows();
        }

        this.buttons.forEach(btn => btn.addEventListener('click', this.handleClick.bind(this)));
      }

      toggleRows() {
        this.tableRows.forEach(( row, idx) => {
          if ((idx + 1) > this.rowsToShow) row.classList.toggle('hidden');
        });
      }

      handleClick() {
        this.buttons.forEach(btn => btn.classList.toggle('hidden'));
        this.toggleRows();
      }

    }
  );
}
